var map = {
	"./blaueskreuz-musub-logo": 7,
	"./blaueskreuz-musub-logo.jpg": 7,
	"./donate/twint-qr-code": 8,
	"./donate/twint-qr-code.jpg": 8,
	"./icons/logo": 9,
	"./icons/logo-short": 10,
	"./icons/logo-short.svg": 10,
	"./icons/logo-sqs": 11,
	"./icons/logo-sqs.png": 11,
	"./icons/logo.svg": 9,
	"./icons/mail-circle": 12,
	"./icons/mail-circle.svg": 12,
	"./icons/online-circle": 13,
	"./icons/online-circle.svg": 13,
	"./icons/phone-circle": 14,
	"./icons/phone-circle.svg": 14,
	"./locations/basel": 15,
	"./locations/basel-map": 16,
	"./locations/basel-map.jpg": 16,
	"./locations/basel.jpg": 15,
	"./locations/liestal": 17,
	"./locations/liestal-map": 18,
	"./locations/liestal-map.jpg": 18,
	"./locations/liestal.jpg": 17,
	"./locations/muenchenstein": 19,
	"./locations/muenchenstein-map": 20,
	"./locations/muenchenstein-map.jpg": 20,
	"./locations/muenchenstein.jpg": 19,
	"./og-bkbb-musub-logo": 21,
	"./og-bkbb-musub-logo.jpg": 21,
	"./partner/baselland-amt-fuer-gesundheit": 22,
	"./partner/baselland-amt-fuer-gesundheit.png": 22,
	"./partner/baselstadt-medizinische-dienste": 23,
	"./partner/baselstadt-medizinische-dienste.png": 23,
	"./partner/prevent-bs": 24,
	"./partner/prevent-bs.jpg": 24,
	"./partner/psychiatrie-baselland": 25,
	"./partner/psychiatrie-baselland.png": 25,
	"./partner/safezone": 26,
	"./partner/safezone.png": 26,
	"./partner/upk-basel": 27,
	"./partner/upk-basel.png": 27,
	"./placeholders/angebot": 28,
	"./placeholders/angebot.jpg": 28,
	"./placeholders/angehoerige": 29,
	"./placeholders/angehoerige.jpg": 29,
	"./placeholders/arbeitgeber": 30,
	"./placeholders/arbeitgeber.jpg": 30,
	"./placeholders/article-placeholder": 31,
	"./placeholders/article-placeholder.jpg": 31,
	"./placeholders/beistandschaften": 32,
	"./placeholders/beistandschaften.jpg": 32,
	"./placeholders/betroffene": 33,
	"./placeholders/betroffene.jpg": 33,
	"./placeholders/covid": 34,
	"./placeholders/covid.jpg": 34,
	"./placeholders/empfang": 35,
	"./placeholders/empfang.jpg": 35,
	"./placeholders/entzug": 36,
	"./placeholders/entzug.jpg": 36,
	"./placeholders/gruppenprogramm": 37,
	"./placeholders/gruppenprogramm.jpg": 37,
	"./placeholders/jugendliche": 38,
	"./placeholders/jugendliche.jpg": 38,
	"./placeholders/kaufsucht": 39,
	"./placeholders/kaufsucht.jpg": 39,
	"./placeholders/praevention": 40,
	"./placeholders/praevention.jpg": 40,
	"./placeholders/psychiatrische-sprechstunde": 41,
	"./placeholders/psychiatrische-sprechstunde.jpg": 41,
	"./placeholders/schulsozialdienst": 42,
	"./placeholders/schulsozialdienst.jpg": 42,
	"./placeholders/spenden": 43,
	"./placeholders/spenden-box": 44,
	"./placeholders/spenden-box.jpg": 44,
	"./placeholders/spenden.jpg": 43,
	"./placeholders/substances": 45,
	"./placeholders/substances.jpg": 45,
	"./placeholders/team": 46,
	"./placeholders/team.jpg": 46,
	"./placeholders/villa": 47,
	"./placeholders/villa.jpg": 47,
	"./placeholders/worker-placeholder": 48,
	"./placeholders/worker-placeholder.jpg": 48,
	"./prevention_form/alkohol": 49,
	"./prevention_form/alkohol.svg": 49,
	"./prevention_form/cannabis": 50,
	"./prevention_form/cannabis.svg": 50,
	"./prevention_form/gaming": 51,
	"./prevention_form/gaming.svg": 51,
	"./prevention_form/gluecksspiele": 52,
	"./prevention_form/gluecksspiele.svg": 52,
	"./prevention_form/kaufsucht": 53,
	"./prevention_form/kaufsucht.svg": 53,
	"./prevention_form/kennenlernen": 54,
	"./prevention_form/kennenlernen.svg": 54,
	"./prevention_form/koerperbild": 55,
	"./prevention_form/koerperbild.svg": 55,
	"./prevention_form/lebenskompetenz": 56,
	"./prevention_form/lebenskompetenz.svg": 56,
	"./prevention_form/mischkonsum": 57,
	"./prevention_form/mischkonsum.svg": 57,
	"./prevention_form/mobbing": 58,
	"./prevention_form/mobbing.svg": 58,
	"./prevention_form/partydrogen": 59,
	"./prevention_form/partydrogen.svg": 59,
	"./prevention_form/resilienz": 60,
	"./prevention_form/resilienz.svg": 60,
	"./prevention_form/snus": 61,
	"./prevention_form/snus.svg": 61,
	"./prevention_form/soziale-medien": 62,
	"./prevention_form/soziale-medien.svg": 62,
	"./prevention_form/stress": 63,
	"./prevention_form/stress.svg": 63,
	"./prevention_form/sucht": 64,
	"./prevention_form/sucht.svg": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71;